// This must be the first line in src/index.js
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from "connected-react-router";
import { store, persistor, history } from './store/store';
import { PersistGate } from 'redux-persist/lib/integration/react';
// import i18n (needs to be bundled ;))
import './i18n';

import App from './App';

import './index.css';

const isIframe = window !== window.parent && !window.opener;
// console.log('isIFrame ->', isIframe);

// https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/FAQs#q6-how-to-avoid-page-reloads-when-acquiring-and-renewing-tokens-silently
if (isIframe) {
	ReactDOM.render(<React.Fragment/>,
		document.getElementById('root'));
} else {
	ReactDOM.render(
		<Provider store={store}>
			<PersistGate loading={<div />} persistor={persistor}>
				<ConnectedRouter history={history}>
					<App/>
				</ConnectedRouter>
			</PersistGate>
		</Provider>,
		document.getElementById('root')
	);
}
